var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSourCherry = function SvgSourCherry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sour-cherry_svg__a)",
    d: "M175 112a42.85 42.85 0 0 0-17-4 164 164 0 0 0-20.025 1c-16.988 1.885-22.975-1-30.975-1-1.717 0-2 1.614-2 5 0 7 9 21 18 21 12 0 56-3 56-10 0-4-2.049-10.2-4-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sour-cherry_svg__b)",
    d: "M127.969 122.424a22.3 22.3 0 0 0 8.9 1.576 28.3 28.3 0 0 0 8.135-1.143s-6.876-4.168-8.516-10.146c-1.6-5.845-6.563-40.8-8.484-49.663-.361-1.668-1-3.048-2-3.048-1.469 0-3 3.048-3 7.111-.011 1.479.14 2.954.451 4.4 6.47 25.931 4.514 50.913 4.514 50.913"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sour-cherry_svg__c)",
    d: "M166.788 110c11.971 0 22.19 11.917 23.942 28.977 2.57 25.025-12.969 71.113-56.863 71.025-40.9-.082-54.867-40.05-54.867-64.03 0-21.983 17.245-37.97 27.932-37.97 15.962 0 11.972 14.988 29.928 14.988 16.086-.002 20.95-12.99 29.928-12.99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sour-cherry_svg__a",
    x1: 140.002,
    x2: 140.959,
    y1: 125.391,
    y2: 94.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#409CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#77B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#A5D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#C8E2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E2F0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#F1F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sour-cherry_svg__b",
    x1: 136.512,
    x2: 102.046,
    y1: 122.857,
    y2: 89.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sour-cherry_svg__c",
    x1: 79,
    x2: 191,
    y1: 159.002,
    y2: 159.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgSourCherry;